import script from "./ResultPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultPage.vue?vue&type=script&setup=true&lang=js"

import "./ResultPage.vue?vue&type=style&index=0&id=548bfa24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-548bfa24"]])

export default __exports__